import React, { useState } from 'react';
import {
  TextField,
  Box,
  Grid,
  CircularProgress,
} from '@mui/material';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import {
  Item,
  WelcomeTextStyling,
  ButtonStyle,
} from './style';
import route from '../../utils/route';
import NavigateSnackbar from '../navigateSnackbar/NavigateSnackbar';
import profileService from '../../services/profile.service';
import { ProfileStatus } from '../../utils/constants';

function ProfileCreate() {
  const location = useLocation();
  const navigate = useNavigate();
  const { cId, groupsId } = useParams();
  const initialValues = {
    companyId: cId,
    groupId: groupsId,
    profileName: '',
    profileStatus: ProfileStatus.STATUS,
  };
  const [loading, setLoading] = useState(false);
  const [snackbar, setSnackbar] = useState({
    state: false,
    navigateText: '',
    message: '',
    severity: 'success',
  });
  const profileName = RegExp(/^[A-Za-z0-9 ]*$/);
  const signUpSchema = Yup.object({
    profileName: Yup.string().matches(profileName, 'Please enter valid Profile name!').max(30, 'Should be 15 or less than 15 characters')
      .required('Profile name is required'),
  });
  const handleClick = async (values) => {
    try {
      setLoading(true);
      await profileService.addProfile(values);
      setSnackbar({
        navigateText: '',
        severity: 'success',
        state: true,
        message: 'Profile Created ..!',
      });
      setTimeout(() => {
        navigate(`/${route.PROFILE_PAGE}`);
      }, 2000);
    } catch (err) {
      setSnackbar({
        navigateText: '',
        severity: 'error',
        state: true,
        message: `${err.data.message}`,
      });
    } finally {
      setLoading(false);
    }
  };
  const {
    values,
    errors,
    handleChange,
    handleBlur,
    handleSubmit,
  } = useFormik({
    initialValues,
    validationSchema: signUpSchema,
    onSubmit: () => {
      handleClick(values);
    },
  });
  return (
    <>
      {
        location.pathname === `/createProflie/${cId}/${groupsId}` && (
          <Box
            sx={{
              marginTop: '100px',
            }}
          >
            <Grid item xs={7}>
              <WelcomeTextStyling> Profile Create </WelcomeTextStyling>
            </Grid>
            <form onSubmit={handleSubmit}>
              <Grid
                container
                rowSpacing={3}
                direction="column"
                alignItems="center"
                justifyContent="center"
                style={{ marginTop: '9px' }}
              >
                <Grid item xs={7}>
                  <TextField
                    label="Profile name *"
                    name="profileName"
                    value={values.profileName}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    error={errors.profileName}
                    helperText={errors.profileName}
                    placeholder="New Company"
                  />
                </Grid>
                <Grid item xs={7} style={{ cursor: 'pointer' }}>
                  {loading && <CircularProgress style={{ marginLeft: '35px' }} />}
                  {
                    !loading && <Item><ButtonStyle type="submit" variant="contained" style={{ width: '155px', cursor: 'pointer' }}>SUBMIT</ButtonStyle></Item>
                  }
                </Grid>
              </Grid>
            </form>
            {
              snackbar.state
              && (
                <NavigateSnackbar
                  snackbarObj={snackbar}
                  setSnackbar={setSnackbar}
                />
              )
            }
          </Box>
        )
      }
    </>
  );
}

export default ProfileCreate;
